// extracted by mini-css-extract-plugin
export default {"result":"ResultsTable_result__I7x2j"};